import React, { useState } from "react";
import ChallengeItem from "./ChallengeItem";

function CurriculumTree({ curriculum, selectedChallenge, onSelectChallenge }) {
  const [expandedWeeks, setExpandedWeeks] = useState(() => {
    // Expand released weeks by default
    return curriculum.filter((w) => w.released).map((w) => w.id);
  });

  const toggleWeek = (weekId) => {
    setExpandedWeeks((prev) =>
      prev.includes(weekId) ? prev.filter((w) => w !== weekId) : [...prev, weekId]
    );
  };

  const formatReleaseDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };

  return (
    <div className="space-y-2">
      {curriculum.map((week) => {
        // Check if all challenges in this week are completed
        const allChallenges = week.items || [];
        const completedChallenges = allChallenges.filter(
          (item) => item.status === "Completed"
        );
        const isWeekCompleted =
          allChallenges.length > 0 &&
          completedChallenges.length === allChallenges.length;

        const completionPercentage = allChallenges.length > 0
          ? Math.round((completedChallenges.length / allChallenges.length) * 100)
          : 0;

        return (
          <div key={week.id} className="rounded-lg overflow-hidden">
            {/* Week Header */}
            <button
              onClick={() => week.released && toggleWeek(week.id)}
              disabled={!week.released}
              className={`w-full px-3 py-2.5 rounded-lg transition-colors ${
                week.released
                  ? isWeekCompleted
                    ? "bg-emerald-900/30 hover:bg-emerald-900/40 cursor-pointer border border-emerald-500/50"
                    : "bg-zinc-800/50 hover:bg-zinc-800 cursor-pointer"
                  : "bg-zinc-900/30 cursor-not-allowed opacity-50"
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 min-w-0">
                  <span
                    className={`font-mono text-xs flex-shrink-0 ${
                      week.released
                        ? isWeekCompleted
                          ? "text-emerald-400"
                          : "text-amber-400"
                        : "text-zinc-600"
                    }`}
                  >
                    W{week.week}
                  </span>
                  <span
                    className={`font-display text-sm truncate ${
                      week.released ? "text-zinc-200" : "text-zinc-600"
                    }`}
                  >
                    {week.released
                      ? week.title
                      : `Releases ${formatReleaseDate(week.releaseDate)}`}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  {week.released && (
                    <span className={`text-xs font-mono ${
                      isWeekCompleted ? "text-emerald-400" : "text-zinc-500"
                    }`}>
                      {completedChallenges.length}/{allChallenges.length}
                    </span>
                  )}
                  {week.released && (
                    <svg
                      className={`w-4 h-4 text-zinc-500 transition-transform ${
                        expandedWeeks.includes(week.id) ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  )}
                </div>
              </div>

              {/* Progress Bar */}
              {week.released && allChallenges.length > 0 && (
                <div className="mt-2 w-full bg-zinc-700/50 rounded-full h-1.5 overflow-hidden">
                  <div
                    className={`h-full transition-all duration-500 ${
                      isWeekCompleted
                        ? "bg-emerald-500"
                        : "bg-amber-500"
                    }`}
                    style={{ width: `${completionPercentage}%` }}
                  />
                </div>
              )}
            </button>

          {/* Week Items */}
          {week.released && expandedWeeks.includes(week.id) && (
            <div className="mt-1 space-y-1 pl-2">
              {week.items.map((item) => (
                <ChallengeItem
                  key={item.id}
                  item={item}
                  isSelected={selectedChallenge?.id === item.id}
                  onClick={onSelectChallenge}
                />
              ))}
            </div>
          )}
          </div>
        );
      })}
    </div>
  );
}

export default CurriculumTree;
